module.exports = __webpack_public_path__ + "img/Thanks.0187ac3d.jpg";